var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPlantBadge = function SvgPlantBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#7FCB7F",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#1F1F1F",
    cx: 12,
    cy: 12,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.75H6C6 11.65 8.35 14 11.25 14v3.375c0 .206.169.375.375.375h.75a.376.376 0 00.375-.375V14c0-2.9-2.35-5.25-5.25-5.25zm9-1.5a5.246 5.246 0 00-4.587 2.7 6.009 6.009 0 011.383 2.522A5.252 5.252 0 0018 7.25h-1.5z",
    fill: "#1F1F1F",
    fillRule: "nonzero"
  }))));
};

export default SvgPlantBadge;